import { ErrorMessage as HookFormErrorMessage } from '@hookform/error-message'
import classNames from 'classnames'
import { forwardRef, LegacyRef, useImperativeHandle, useRef } from 'react'
import { FieldErrors, FieldValues } from 'react-hook-form'
import ErrorMessage from '../ErrorMessage'

interface TextAreaProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  label?: string
  containerClassName?: string
  labelClassName?: string
  textAreaClassName?: string
  customOnChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  errors?: FieldErrors<FieldValues>
}

const TextArea = forwardRef<HTMLInputElement, TextAreaProps>((props, ref) => {
  const { name, label, errors, placeholder, containerClassName, labelClassName, textAreaClassName, ...inputProps } = props

  const inputRef = useRef<HTMLInputElement>(null)

  useImperativeHandle(ref, () => inputRef.current!)

  return (
    <div className={containerClassName}>
      {label && (
        <label className={labelClassName} htmlFor={name}>
          {label}
        </label>
      )}
      <textarea
        {...inputProps}
        ref={inputRef as LegacyRef<HTMLTextAreaElement>}
        autoComplete="off"
        id={name}
        name={name}
        className={classNames('text-KMRS-Darkmode px-5 py-5 rounded-3xl bg-KMRS-Light focus:outline-hidden', textAreaClassName)}
        placeholder={placeholder}
      />
      {errors && name && <HookFormErrorMessage errors={errors} name={name} render={({ message }) => <ErrorMessage message={message} />} />}
    </div>
  )
})

TextArea.displayName = 'TextArea'

export default TextArea
